module.exports = __webpack_public_path__ + "media/images/medico_ficha-f716d8c20b845853268307229b602d80.svg";